module.exports = __webpack_public_path__ + "components/flag/static/square/cm-b99d016f9deaed66ab09887011b9f849.svg";